export enum ListSortEnum {
	author = 'author',
	type = 'type',
	date = 'date',
	fields = 'fields'
}
